import homeComponent from './home.component';

let homeModule = angular.module('home', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/home');

  $stateProvider
    .state('home', {
      url: '/home',
      component: 'home',
      data: {
        requireLogin: true
      },
      parent:'app',
    });
})

.component('home', homeComponent)

.name;

export default homeModule;


// WEBPACK FOOTER //
// ./client/app/components/home/home.js